<div class="user-menu-container" [style.height.px]="navbarHeight">
  <!-- User Avatar Button -->
  <button 
    class="user-avatar-button" 
    (click)="toggleMenu()"
    [attr.aria-label]="'User menu for ' + getDisplayName()"
    data-automation="user-menu-button"
  >
    <div class="user-avatar">
      {{ getUserInitials() }}
    </div>
  </button>

  <!-- Backdrop -->
  <div 
    class="user-menu-backdrop" 
    *ngIf="isMenuOpen"
    [style.top.px]="navbarHeight"
    [style.height]="'calc(100vh - ' + navbarHeight + 'px)'"
    (click)="closeMenu()"
    [@fadeInOut]
  ></div>

  <!-- Side Menu Panel -->
  <div 
    *ngIf="isMenuOpen"
    class="user-menu-panel"
    [style.top.px]="navbarHeight"
    [style.height]="'calc(100vh - ' + navbarHeight + 'px)'"
    [@slideInOut]
    data-automation="user-menu-panel"
  >
    <!-- Header (matching old .profile-header) -->
    <div class="user-menu-header">
      <div class="user-avatar-large">
        {{ getUserInitials() }}
      </div>
      <div class="name-org">
        <div class="user-name" [title]="getDisplayName()">
          {{ getDisplayName() }}
        </div>
        <div class="user-org" [title]="getEmail()">
          {{ getEmail() }}
        </div>
      </div>
      <button 
        *ngIf="!isEditMode"
        class="edit-profile-button" 
        (click)="enterEditMode()"
        [attr.aria-label]="'Edit preferences'"
        title="Edit preferences"
        data-automation="edit-profile-button"
      >
        <mat-icon>edit</mat-icon>
      </button>
    </div>

    <!-- Content with expansion panels (matching old structure) -->
    <div class="user-menu-content">
      <!-- Contact Information Section -->
      <mat-expansion-panel [expanded]="true" togglePosition="after">
        <mat-expansion-panel-header collapsedHeight="42px" expandedHeight="42px">
          <mat-panel-title>{{ 'user.menu.contact_info' | translate }}</mat-panel-title>
        </mat-expansion-panel-header>
        
        <div class="field-wrapper">
          <div class="user-label">{{ 'user.menu.username' | translate }}</div>
          <div class="user-text">{{ getUsername() }}</div>
        </div>

        <div class="field-wrapper">
          <div class="user-label">{{ 'user.menu.email' | translate }}</div>
          <div class="user-text">{{ getEmail() }}</div>
        </div>

        <div class="field-wrapper">
          <div class="user-label">{{ 'user.menu.title' | translate }}</div>
          <div class="user-text">{{ getTitle() }}</div>
        </div>
      </mat-expansion-panel>

      <!-- User Preferences Section -->
      <mat-expansion-panel [expanded]="true" togglePosition="after">
        <mat-expansion-panel-header collapsedHeight="42px" expandedHeight="42px">
          <mat-panel-title>{{ 'user.menu.preferences' | translate }}</mat-panel-title>
        </mat-expansion-panel-header>
        
        <div class="field-wrapper">
          <div class="user-label">{{ 'user.menu.locale' | translate }}</div>
          <div class="user-text">{{ getLocaleDisplay() }}</div>
        </div>

        <div class="field-wrapper">
          <div class="user-label" *ngIf="!isEditMode">{{ 'user.menu.timezone' | translate }}</div>
          <div class="user-text" *ngIf="!isEditMode">{{ getTimezoneDisplay() }}</div>
          <mat-form-field *ngIf="isEditMode" appearance="outline" class="edit-field">
            <mat-label>{{ 'user.menu.timezone' | translate }}</mat-label>
            <mat-select
              [(ngModel)]="editablePreferences.timeZone"
              panelClass="user-menu-select"
              disableOptionCentering
              data-automation="timezone-select"
            >
              <mat-option *ngFor="let tz of availableTimezones" [value]="tz.timezoneName">
                {{ tz.displayLabel }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="field-wrapper">
          <div class="user-label" *ngIf="!isEditMode">{{ 'user.menu.measurement' | translate }}</div>
          <div class="user-text" *ngIf="!isEditMode">{{ getMeasurement() }}</div>
          <mat-form-field *ngIf="isEditMode" appearance="outline" class="edit-field">
            <mat-label>{{ 'user.menu.measurement' | translate }}</mat-label>
            <mat-select
              [(ngModel)]="editablePreferences.systemMeasurementUnit"
              panelClass="user-menu-select"
              disableOptionCentering
              data-automation="measurement-select"
            >
              <mat-option *ngFor="let option of measurementOptions" [value]="option">
                {{ option }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="field-wrapper">
          <div class="user-label">{{ 'user.menu.home_app' | translate }}</div>
          <div class="user-text">{{ getHomeApp() }}</div>
        </div>
      </mat-expansion-panel>
    </div>

    <!-- Footer (matching old .profile-button-wrapper) -->
    <div class="user-menu-footer">
      <div *ngIf="isEditMode" class="edit-actions">
        <button 
          class="action-button update-button" 
          (click)="savePreferences()"
          data-automation="update-button"
        >
          <mat-icon>check</mat-icon>
          <span>Update</span>
        </button>
        <button 
          class="action-button cancel-button" 
          (click)="cancelEdit()"
          data-automation="cancel-button"
        >
          <mat-icon>close</mat-icon>
          <span>Cancel</span>
        </button>
      </div>
      <button 
        *ngIf="!isEditMode"
        class="logout-button" 
        (click)="logout()"
        data-automation="logout-button"
      >
        <mat-icon>logout</mat-icon>
        <span>{{ 'user.menu.logout' | translate }}</span>
      </button>
    </div>
  </div>
</div>
